import React from "react";
import PropTypes from "prop-types";
import cname from "../../style.module.scss";
import { isActivationKey } from "@learningblocks/shared-components";

/**
 *  @argument children: List of tabs to enter sectiion
 */

export function Tabs(props: { children: React.ReactNode }) {
  return <ul className={cname.tabs}>{props.children}</ul>;
}

export function Tab(props: {
  onClick: (_: string) => void;
  label: string;
  current: boolean;
}) {
  const getCname = () => {
    let className = cname.tab;
    if (props.current) {
      className += ` ${cname.current}`;
    }
    return className;
  };
  const onClick = () => props.onClick(props.label);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (isActivationKey(e)) {
      onClick();
    }
  };

  return (
    <li className={getCname()}>
      <span
        role={"button"}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        {props.label}
      </span>
    </li>
  );
}

Tab.propTypes = {
  /**
   * Label of the tab
   */
  label: PropTypes.string,
  /**
   * Boolen set if tab is current
   */
  current: PropTypes.bool,
  /**
   * Callback for when a tab is clicked
   */
  onClick: PropTypes.func,
};
